// extracted by mini-css-extract-plugin
export var cartContainer = "_o0-4";
export var gray = "_o0-1";
export var itemContainer = "_o0-2";
export var itemDetails = "_o0-3";
export var strong = "_o0-0";